<template>
    <form class="card">
        <h3>Общее</h3>
        <div class="inline" v-if="status == ''">
            <div class="grid">
                <div class="text-item" v-if="data.creator">
                    <span>Создатель</span>
                    <p><router-link :to="'/users/' + data.creator.id">{{ data.creator.email }}</router-link></p>
                </div>

                <div class="text-item" v-for="(item, index) of data.owner_authorizations" :key="'o'+index">
                    <span>Владелец #{{ item.id }}</span>
                    <p><router-link :to="'/users/' + item.user.id">{{ item.user.email }}</router-link></p>
                </div>

                <div class="text-item" v-if="data.editor">
                    <span>Редактор</span>
                    <p><router-link :to="'/users/' + data.editor.id">{{ data.editor.email }}</router-link></p>
                </div>
                <CoordsPicker :address.sync="data.address" :lat.sync="data.lat" :lng.sync="data.lng"></CoordsPicker>

                <div class="text-item">
                    <span>Статус</span>
                    <p>{{ data.status_new_text }}</p>
                </div>

                <div class="form-item">
                    <label for="descr">Описание</label>
                    <input type="text" id="descr" class="text-input" v-model="data.description" />
                </div>

                <div class="inline form-item" :status="request_status">
                    <div v-if="data.published" class="text-accept">Опубликовано</div>
                    <div v-if="data.deleted"  class="text-decline">Удалено</div>

                    <div v-if="!data.published" class="button _free _accept" @click="publicParking()">Опубликовать</div>
                    <div v-if="!data.deleted" class="button _free _decline" @click="removeParking()">Удалить</div>
                    <div class="button _free _second" @click="$emit('showPopup', {popup: 'rollback', text: $route.params.id})" v-if="data.rollback_possible">Откат</div>
                </div>

                <div class="rating" v-if="data.rating">
                    <p class="rating-header inline" valign="center">Рейтинг: <strong>{{ data.rating }}</strong></p>
                    <div class="rating-item inline" v-for="(rating, index) in data.ratings" :key="index">
                        <strong>{{ rating.rate }}</strong>
                        <p>
                            <router-link :to="'/users/' + rating.user.id">{{ rating.user.firstname + ' ' + rating.user.lastname }}</router-link>
                            {{ rating.text }}
                        </p>
                    </div>
                </div>
            </div>
            <div class="grid">
                <div class="form-item" v-if="data.photo">
                    <ZoomImage :src="data.photo.big"/>
                </div>
                <div class="form-item">
                    <label for="descr">Фотография</label>
                    <input type="file" accept="image/*" @change="uploadImage($event)" id="file-input">
                </div>
            </div>
        </div>

    </form>
</template>

<script>
    import CoordsPicker from '@/components/CoordsPicker.vue'
    import ZoomImage from '@/components/ZoomImage.vue'

    export default {
        components: {
            CoordsPicker,
            ZoomImage
        },
        props: ['status', 'data'],
        data () {
            return {
                request_status: ''
            }
        },
        created () {
            this.$emit('getData')
        },
        methods: {
            rollBack () {

            },
            uploadImage (event) {
                let data = new FormData();
                data.append('photo', event.target.files[0]);

                this.axios.post('api/admin/v2/parking/' + this.$route.params.id + '/photo', data, {
                    header : {
                        'Content-Type' : 'multipart/form-data'
                    }
                }).then((resp) => {
                    if (resp.data.status) {
                        this.data.photo = resp.data.response.photo
                    } else {
                        let msg = {
                            message: 'Ошибка при загрузке фото',
                            status: 'error'
                        }
                        this.$store.dispatch('utils/showMessage', msg)
                    }
                    event.target.value = ''
                }).catch(() => {
                    let msg = {
                        message: 'Ошибка при загрузке фото',
                        status: 'error'
                    }
                    this.$store.dispatch('utils/showMessage', msg)
                    event.target.value = ''
                })
            },
            publicParking() {
                return new Promise((resolve, reject) => {
                    this.request_status = 'loading'
                    this.axios.post('api/admin/v2/parking/' + this.$route.params.id + '/publish')
                        .then(() => {
                            this.request_status = ''
                            this.data.published = true
                            this.data.deleted = false
                            resolve()
                        })
                        .catch(() => {
                            this.request_status = ''
                            let msg = {
                                message: 'Ошибка при публикации парковки',
                                status: 'error'
                            }
                            this.$store.dispatch('utils/showMessage', msg)
                            reject()
                        })
                })
            },
            removeParking () {
                return new Promise((resolve, reject) => {
                    this.request_status = 'loading'
                    this.axios.post('api/admin/v2/parking/' + this.$route.params.id + '/delete')
                        .then(() => {
                            this.request_status = ''
                            this.data.deleted = true
                            this.data.published = false
                            resolve()
                        })
                        .catch(() => {
                            this.request_status = ''
                            let msg = {
                                message: 'Ошибка при удалении парковки',
                                status: 'error'
                            }
                            this.$store.dispatch('utils/showMessage', msg)
                            reject()
                        })
                })
            }
        }
    }
</script>